import React from "react";
import { TimerIcon } from "lucide-react";
import { useCountdown } from "../hooks/useCountdown";
const START_SECONDS = 17 * 60 + 34;
interface CountdownProps {
  dark?: boolean;
}
export function Countdown({
  dark = false
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(START_SECONDS);
  const units = [{
    label: "Hours",
    value: hours
  }, {
    label: "Minutes",
    value: minutes
  }, {
    label: "Seconds",
    value: seconds
  }];
  return <div className="mx-auto mt-6 w-full max-w-xl text-center" role="timer" aria-live="off" data-id="element-95" data-mp="3c48nmbr7mpd8">
      <p className={`flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-wide ${dark ? "text-white" : "text-ink"}`} data-id="element-96" data-mp="3gymfi46nyed5">
        <TimerIcon className="h-4 w-4 text-before" aria-hidden="true" data-id="element-97" data-mp="371zwzm1t7zea" />
        Launch price reserved for
      </p>
      <div className="mt-3 flex items-start justify-center gap-2" data-id="element-98" data-mp="10dmy3kg9of7h">
        {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-99" data-mp="15a51afvy85hp" data-mpi={i}>
            <div className="w-[84px]" data-id="element-100" data-mp="y16m3ddt2bsa">
              <div className="rounded-xl bg-before py-3 font-display text-4xl font-extrabold tabular-nums text-white shadow-[0_4px_0_0_#9E2328]" data-id="element-101" data-mp="y04yyajilyu7">
                {String(unit.value).padStart(2, "0")}
              </div>
              <p className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wider ${dark ? "text-white/60" : "text-muted"}`} data-id="element-102" data-mp="17qgeyvgh3yhg">
                {unit.label}
              </p>
            </div>
            {i < units.length - 1 && <span className={`pt-2 font-display text-3xl font-extrabold ${dark ? "text-white/50" : "text-ink/40"}`} data-id="element-103" data-mp="a37mggi21p5y">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}